import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { searchStore } from "@/hooks";
import {
  FlexBox,
  ArtifactTypeInput,
  TextInput,
  TextButton,
  ExpansionItem,
} from "@/components/common";


/**
 * Displays inputs for refining a search query and generating search results.
 */
const __default__ = {
  name: "SearchInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const advancedOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    column: "",
    y: "2",
    x: "2",
    style: {"max-width":"40vw"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ArtifactTypeInput), {
        modelValue: _unref(searchStore).searchTypes,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).searchTypes) = $event)),
        multiple: "",
        clearable: "",
        label: "Search Artifact Types",
        hint: "What types am I generating relationships to.",
        class: "full-width",
        style: {"min-width":"250px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(FlexBox), {
        "full-width": "",
        column: advancedOpen.value,
        align: advancedOpen.value ? 'end' : 'center'
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ExpansionItem), {
            modelValue: advancedOpen.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((advancedOpen).value = $event)),
            label: "Advanced Search",
            class: "full-width q-my-sm",
            style: {"transition":"width 0.5s ease-in-out"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FlexBox), { "full-width": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArtifactTypeInput), {
                    modelValue: _unref(searchStore).relatedTypes,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).relatedTypes) = $event)),
                    multiple: "",
                    clearable: "",
                    label: "Include Artifact Types",
                    hint: "What types do I want to see related to my search.",
                    class: "full-width"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(TextInput), {
                    modelValue: _unref(searchStore).maxResults,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).maxResults) = $event)),
                    type: "number",
                    label: "Max Results",
                    class: "q-ml-sm",
                    hint: "The maximum number of search results to display.",
                    style: {"min-width":"130px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _withDirectives(_createVNode(_unref(TextButton), {
            align: "end",
            color: "primary",
            label: "Search",
            class: "q-ml-sm",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('submit')))
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      }, 8, ["column", "align"])
    ]),
    _: 1
  }))
}
}

})